import type { ComponentProps } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const textareaVariants = cva(
  'border-input placeholder:text-placeholder-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content w-full rounded-md border bg-card text-foreground transition-[background-color,border-color,box-shadow,color] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:placeholder:text-muted-foreground',
  {
    variants: {
      size: {
        default: 'min-h-20 px-3 py-2 text-base md:text-sm',
        compact: 'min-h-10 px-3 py-2 text-sm',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

export type TextareaProps = ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>

function Textarea({ className, size = 'default', ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      data-size={size}
      className={cn(textareaVariants({ size }), className)}
      {...props}
    />
  )
}

export { Textarea, textareaVariants }
